const C = {
  name: "Cellular",
  dimensions: { width: 40, height: 41 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_27_2090)">
    <path d="M35 2.00293V37.0029C35 37.5529 35.45 38.0029 36 38.0029H38V3.00293C38 2.45293 37.55 2.00293 37 2.00293H35ZM38 40.0029H35C33.9 40.0029 33 39.1029 33 38.0029V2.00293C33 0.90293 33.9 0.00292969 35 0.00292969H38C39.1 0.00292969 40 0.90293 40 2.00293V38.0029C40 39.1029 39.1 40.0029 38 40.0029Z" />
    <path d="M2 29.0029V37.0029C2 37.5529 2.45 38.0029 3 38.0029H5V30.0029C5 29.4529 4.55 29.0029 4 29.0029H2ZM5 40.0029H2C0.9 40.0029 0 39.1029 0 38.0029V29.0029C0 27.9029 0.9 27.0029 2 27.0029H5C6.1 27.0029 7 27.9029 7 29.0029V38.0029C7 39.1029 6.1 40.0029 5 40.0029Z" />
    <path d="M13 20.0029V37.0029C13 37.5529 13.45 38.0029 14 38.0029H16V21.0029C16 20.4529 15.55 20.0029 15 20.0029H13ZM16 40.0029H13C11.9 40.0029 11 39.1029 11 38.0029V20.0029C11 18.9029 11.9 18.0029 13 18.0029H16C17.1 18.0029 18 18.9029 18 20.0029V38.0029C18 39.1029 17.1 40.0029 16 40.0029Z" />
    <path d="M24 11.0029V37.0029C24 37.5529 24.45 38.0029 25 38.0029H27V12.0029C27 11.4529 26.55 11.0029 26 11.0029H24ZM27 40.0029H24C22.9 40.0029 22 39.1029 22 38.0029V11.0029C22 9.90293 22.9 9.00293 24 9.00293H27C28.1 9.00293 29 9.90293 29 11.0029V38.0029C29 39.1029 28.1 40.0029 27 40.0029Z" />
    </g>
    <defs>
    <clipPath id="clip0_27_2090">
    <rect width="40" height="40" fill="currentColor" transform="translate(0 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  C as Cellular
};
